<template>
  <div class="home-container">
    <div class="home-container-left">
      <div class="home-title-content">
        <vue-typer
          :text="['EXPLORE', 'CREATE', 'DISCOVER']"
          :repeat="Infinity"
          :shuffle="true"
          initial-action="typing"
          :pre-type-delay="100"
          :type-delay="100"
          :pre-erase-delay="4000"
          :erase-delay="250"
          erase-style="backspace"
          :erase-on-complete="false"
          caret-animation="smooth"
        ></vue-typer>
        <h1 class="home-title-static">
          YOUR
          <span @click="navigateTo('story')" class="home-title-link">ACCESS</span>
        </h1>
        <h1 class="home-title-static bottom">IN ANIXON</h1>
      </div>
    </div>
    <div class="home-container-right">
      <div class="home-subtitle-content">
        <p>Walk your way through the world of fantasy, Anixon.</p>
        <p>
          The choices you make will shape your
          <span>access</span> to different layers of this world.
        </p>
        <p class="subtitle-bold">CLICK "ACCESS" TO PROCEED.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { VueTyper } from "vue-typer";
export default {
  name: "home",
  components: {
    VueTyper
  },
  methods: {
    navigateTo(page) {
      this.$router.push(page);
    }
  },
  created() {}
};
</script>

<style lang="scss">
@import "../assets/css/Scheme.scss";
.home-container {
  background-color: $color_black;
  color: white;
  font-family: $font_first;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  .home-container-left {
    min-width: 414px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 50%;
    .home-title-content {
      width: 65vh;
      @media screen and (max-width: 400px) {
        width: 80%;
      }
      text-align: left;
      .vue-typer {
        font-size: 2em;
        .custom.char.typed {
          color: white;
        }
        .custom.caret {
          width: 8px;
          margin-left: 2px;
          background-color: white;
        }
      }
      .home-title-static {
        margin-bottom: 0;
        font-size: 3em;
        letter-spacing: 3px;
        text-align: center;
        @media screen and (max-width: 400px) {
          font-size: 2em;
        }
        .home-title-link {
          text-decoration: underline;
          text-decoration-color: $color_red;
          cursor: pointer;
          transition: all 0.5s;
          &:visited {
            color: white;
          }
          &:hover {
            text-decoration-color: white;
            color: $color_red;
          }
        }
      }
      .bottom {
        margin-top: 2.5%;
        text-align: right;
      }
    }
  }
  .home-container-right {
    min-width: 414px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 50%;
    background-color: white;
    .home-subtitle-content {
      margin-top: 10vh;
      color: $color_black;
      font-family: $font_second;
      font-size: 1em;
      @media screen and (max-width: 400px) {
        font-size: 0.7em;
      }
      .subtitle-bold {
        margin-top: 1em;
        font-size: 1.25em;
        font-weight: 700;
      }
    }
    .home-information-container {
      color: black;
      align-self: flex-end;
    }
  }
}
</style>
